export const BORDER = '#e2e8f0';

export const buttonSx = { height: 40, textTransform: 'none', fontWeight: 600, borderRadius: 1.5 } as const;

export const panelSx = { borderColor: BORDER, borderRadius: 2, overflow: 'hidden', bgcolor: '#fff' };

export const tableContainerSx = { maxHeight: 'calc(100vh - 420px)', minHeight: 260 };

export const headCellSx = {
  fontWeight: 700,
  fontSize: 12,
  color: '#475569',
  bgcolor: '#f8fafc',
  borderBottom: `1px solid ${BORDER}`,
  whiteSpace: 'nowrap'
};

export const rowSx = { '& td': { borderBottom: '1px solid #f1f5f9', py: 0.75, fontSize: 13, verticalAlign: 'middle' } };

export const smallChipSx = { height: 22, fontSize: 11.5, fontWeight: 600, borderRadius: 1.25 };

export const tabsSx = {
  minHeight: 40,
  '& .MuiTab-root': { minHeight: 40, py: 0.5, px: 2, textTransform: 'none', fontSize: '0.88rem', fontWeight: 600 }
};

export const EMPTY_TEXT = 'не указано';
export const emptySx = { fontSize: 12.5, color: '#94a3b8' };

/** Подпись поля в карточке товара */
export const labelSx = { fontSize: '0.7rem', color: '#64748b', lineHeight: 1.4 };
/** Значение поля в карточке товара */
export const valueSx = { fontSize: '0.84rem', fontWeight: 600, color: '#0f172a', wordBreak: 'break-word', lineHeight: 1.4 } as const;
/** Строка «по какому признаку найдено» и дата сверки */
export const noteSx = { fontSize: '0.72rem', color: '#94a3b8' };
